import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';

import {
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import {
  PageWrapper,
  PageViewport,
  PageActions,
  PageActionsRight,
  PageContent,
} from 'components/PageStyles';
import {
  Grid,
  GridCell,
} from 'components/LayoutGrid';
import Modal from 'components/Modal';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandIamTeamList } from 'containers/ConnectionManager/actions';

import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import Sidebar from 'Workspace/components/WorkspaceSidebar';

import { teamShape } from 'Workspace/types/team';
import { selectTeamList } from 'Workspace/Admin/store/selectors';

import gtmService from 'utils/gtm/gtmService';

import AdminNavigation from '../AdminNavigation';
import CreateTeamModal from './components/CreateTeamModal';
import TeamCard from './components/TeamCard';
import messages from './messages';
import { pageName } from 'utils/gtm/constants';

class TeamsPage extends React.Component {
  state = {
    isCreateTeamModalShown: false,
  }

  componentDidMount() {
    this.props.getTeamList();
    gtmService.pushTelemetryPageActivityAndView({ pageName: pageName.TEAMS_PAGE });
  }

  getSortedTeams(teams) {
    return orderBy(teams, (team) => team.name.replace(/\s/g, '').toLowerCase(), 'asc');
  }

  toggleCreateTeamModal = () => {
    this.setState({
      isCreateTeamModalShown: !this.state.isCreateTeamModalShown,
    });
  }

  render() {
    const { isCreateTeamModalShown } = this.state;
    const { teams } = this.props;

    const sortedTeams = this.getSortedTeams(teams);

    return (
      <PageWrapper>
        <Modal
          visible={isCreateTeamModalShown}
          onDismiss={this.toggleCreateTeamModal}
          title={intl.formatMessage(messages.newTeam)}
        >
          <CreateTeamModal onCreated={this.toggleCreateTeamModal} />
        </Modal>

        <Sidebar navigation={<AdminNavigation selectedKey={'teams'} />} />
        <PageViewport>
          <WorkspaceHeader title={intl.formatMessage(messages.teams)} />
          <PageActions>
            <PageActionsRight>
              <Button primary onClick={this.toggleCreateTeamModal}>
                <MaterialIcon id="add" left />
                {intl.formatMessage(messages.newTeam)}
              </Button>
            </PageActionsRight>
          </PageActions>
          <PageContent>
            <Grid>
              {
                teams &&
                sortedTeams.map((team) => (
                  <GridCell key={team.teamId} span={{ desktop: 4, tablet: 6, mobile: 12 }}>
                    <TeamCard data={team} />
                  </GridCell>
                ))
              }
            </Grid>
          </PageContent>
        </PageViewport>
      </PageWrapper>
    );
  }
}

TeamsPage.propTypes = {
  teams: PropTypes.arrayOf(teamShape),
  getTeamList: PropTypes.func,
  location: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  getTeamList: () => dispatch(commandIamTeamList()),
});

const mapStateToProps = (state) => ({
  teams: selectTeamList(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamsPage);
